import { useBulkDelete, useCustomToast, type NotificationResponse } from '@/shared/lib';
import { useNotification } from './useNotification';

export function useNotificationDelete(
  selectedCount: () => number,
  selectedNotificationsArray: () => number[],
  onDeleteSuccess: (deletedIds: number[]) => void,
  removeFromSelection: (ids: number[]) => void
) {
  const toast = useCustomToast();
  const { deleteNotification, bulkDeleteNotifications } = useNotification();

  const bulkDeleteApiWrapper = async (ids: number[]) => {
    const result = await bulkDeleteNotifications(ids);
    return { data: result };
  };

  const bulkDeleteComposable = useBulkDelete<NotificationResponse>({
    entityName: {
      singular: 'notificação',
      plural: 'notificações',
      gender: 'female',
    },
    bulkDeleteApi: bulkDeleteApiWrapper,
    onDeleteSuccess,
    removeFromSelection,
    selectedCount,
    selectedIds: selectedNotificationsArray,
  });

  const showDeleteSuccessToast = (count: number = 1) => {
    const message =
      count === 1
        ? 'Notificação deletada com sucesso.'
        : `${count} notificações deletadas com sucesso.`;

    toast.showSuccessToast({
      title: message,
      type: 'success',
    });
  };

  const showDeleteErrorToast = (count: number = 1) => {
    const message =
      count === 1
        ? 'Erro ao deletar notificação. Tente novamente.'
        : `Erro ao deletar notificações. Tente novamente.`;

    toast.showErrorToast({
      title: message,
      type: 'error',
    });
  };

  const handleSingleDelete = async (notificationId: number) => {
    try {
      await deleteNotification(notificationId);
      onDeleteSuccess([notificationId]);
      showDeleteSuccessToast();
    } catch (error) {
      console.error('Erro ao deletar notificação:', error);
      showDeleteErrorToast();
    }
  };

  return {
    ...bulkDeleteComposable,
    handleSingleDelete,
    showDeleteSuccessToast,
    showDeleteErrorToast,
  };
}
